import React from "react";
import type { EditorMode } from "./terraDrawController";

interface PolygonDrawToolbarProps {
  mode: EditorMode;
  hasSelection: boolean;
  onMode: (mode: EditorMode) => void;
  onDelete: () => void;
}

const HINTS: Record<EditorMode, string> = {
  polygon: "Click to add points, click the first point to finish, Esc to cancel",
  rectangle: "Click two corners",
  select: "Drag a shape or its points; right-click a point to remove it",
};

const TOOLS: { mode: EditorMode; label: string }[] = [
  { mode: "select", label: "Select" },
  { mode: "polygon", label: "Draw polygon" },
  { mode: "rectangle", label: "Draw rectangle" },
];

/** Top-left tool buttons for the polygon editor, with a one-line hint for the active tool. */
const PolygonDrawToolbar: React.FC<PolygonDrawToolbarProps> = ({ mode, hasSelection, onMode, onDelete }) => (
  <div className="absolute left-3 top-20 z-10 flex max-w-[calc(100%-1.5rem)] flex-col gap-2 sm:max-w-sm">
    <div role="group" aria-label="Drawing tools" className="join flex flex-wrap rounded-box bg-surface shadow-md">
      {TOOLS.map((t) => (
        <button
          key={t.mode}
          type="button"
          aria-pressed={mode === t.mode}
          onClick={() => onMode(t.mode)}
          className={`btn btn-sm join-item ${mode === t.mode ? "btn-primary" : "btn-ghost text-ink"}`}
        >
          {t.label}
        </button>
      ))}
      <button
        type="button"
        disabled={!hasSelection}
        onClick={onDelete}
        className="btn btn-sm btn-ghost join-item text-ink"
      >
        Delete
      </button>
    </div>
    <p className="rounded-box bg-surface px-3 py-1.5 text-xs text-ink-muted shadow-md">{HINTS[mode]}</p>
  </div>
);

export default PolygonDrawToolbar;
